import { h } from 'preact';
import StockDetails from '../stock-details';
import style from './style';
import { containerSize } from '@cube/blocks';
import cx from 'classnames';

export default containerSize({ height: false })(DetailTable);
export function DetailTable({ width, ...props }) {
	return (
		<span>
			<div class={cx(style.quotePanel, width > 600 && style.wide)}>
				<StockDetails
					fields={[
						'prevClose',
						'open',
						'volume'
					]}
					quote={props.quote}
					{...props}
				/>
			</div>
			<div class={cx(style.quotePanel, width > 600 && style.wide)}>
				<StockDetails
					fields={[
						'dayRange',
						'52WeekRange',
						'averageVolume'
					]}
					quote={props.quote}
					{...props}
				/>
			</div>
		</span>
	);
}
